import { APIClient } from "../apiCore";
import * as url from "../urls";
import {m9sGlobals} from "../../config";
import {MainMetaType} from "../../redux/Main/common";
import {createPaginationQuery} from "../../helpers/functions";

const api = new APIClient();

const getSaleOrderStatuses = (data:MainMetaType) => {
    const query = createPaginationQuery(data);
    return api.get(m9sGlobals.CURRENT_CABINET+url.GET_SALE_ORDER_STATUSES+"?"+query);
};

const sendDataSaleOrderStatus = (data: any) => {
    return api.create(m9sGlobals.CURRENT_CABINET+url.UPDATE_SALE_ORDER_STATUS, data);
};

const removeSaleOrderStatus = (data: any) => {
    return api.create(m9sGlobals.CURRENT_CABINET+url.REMOVE_SALE_ORDER_STATUS, data);
};

export {
    getSaleOrderStatuses,
    sendDataSaleOrderStatus,
    removeSaleOrderStatus
};
